import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useState } from 'react'
import ReservationSidebar from '../Commun/ReservationSidebar'
import ReservationHeader from '../Commun/ReservationHeader'
import { Property } from '../../Services/Service';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { fetchBusinessSourceReport } from '../../Redux/Slices/BusinessSourceReportSlice';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as XLSX from "xlsx";
import "./ReservationReportTheme.css";

export const BusinessSourceReport = () => {
    const dispatch = useDispatch();
    const [propertyList, setPropertyList] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState([]);
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [bookingFrom, setBookingFrom] = useState("");
    const [bookingTo, setBookingTo] = useState("");
    const [exportLoadingBusiness, setExportLoadingBusiness] = useState(false);


    const { data, loading } = useSelector((state) => state.businessSourceReport);

    useEffect(() => {
        fetchProperty();
    }, []);

    const fetchProperty = async () => {
        const data = await Property();
        setPropertyList(data);

        // ✅ Sabko default select kar do
        const allSelected = data.map((item) => ({
            value: item.PropertyID,
            label: item.PropertyName,
        }));

        setSelectedProperty(allSelected);
    };


    // Convert API data for react-select
    const propertyOptions = propertyList?.map((item) => ({
        value: item.PropertyID,
        label: item.PropertyName,
    }));

    const handlePropertyChange = (selectedOptions) => {
        setSelectedProperty(selectedOptions || []);
    };

    // ✅ FILTER BUTTON
    useEffect(() => {
        if (selectedProperty.length === 0) return;

        const propertyIds = selectedProperty.map(p => p.value);

        const params = {
            PID: JSON.stringify(propertyIds),
            CheckInDate: checkIn,
            CheckOutDate: checkOut,
            BookingFrom: bookingFrom,
            BookingTo: bookingTo
        };

        dispatch(fetchBusinessSourceReport(params));

    }, [selectedProperty, checkIn, checkOut, bookingFrom, bookingTo, dispatch]);

    // ✅ CLEAR BUTTON
    const handleClear = () => {
        setSelectedProperty([]);
        setCheckIn("");
        setCheckOut("");
        setBookingFrom("");
        setBookingTo("");

        // API call without filters
        const params = {
            PID: JSON.stringify([]),
            CheckInDate: "",
            CheckOutDate: "",
            BookingFrom: "",
            BookingTo: ""
        };

        dispatch(fetchBusinessSourceReport(params));
    };



    const exportBusinessSourceToExcel = () => {
        if (!data || data.length === 0) return;

        try {
            setExportLoadingBusiness(true);

            const formattedData = data.map((item, index) => ({
                "Sr#": index + 1,
                "Business Source": item.BusinessSource,
                "OCC": item.OCC,
                "PAX": item.PAX,
                "Revenue": item.Revenue,
                "ARR": item.ARR
            }));

            const worksheet = XLSX.utils.json_to_sheet(formattedData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Business Source Report");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
            });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "Business_Source_Report.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Business Source Export Error:", error);
        } finally {
            setExportLoadingBusiness(false);
        }
    };

    return (
        <>
            {loading && (
                <FullScreenLoader />
            )}

            {exportLoadingBusiness && (
                <FullScreenLoader />
            )}

            <div className="wrapper ">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner reservation-report-page">

                            <form>
                                <div className='row mb-3'>
                                    <div className='col-md-12'>
                                        <label className='form-label'>Business Source Productivity</label>
                                        <Select
                                            options={propertyOptions}
                                            isMulti
                                            value={selectedProperty}
                                            onChange={handlePropertyChange}
                                            placeholder="Select Property"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-3'>
                                    <div className='col-md-2'>
                                        <label className='form-label'>Check In</label>
                                        <input
                                            type='date'
                                            className='form-control'
                                            value={checkIn}
                                            onChange={(e) => setCheckIn(e.target.value)}
                                        />
                                    </div>

                                    <div className='col-md-2'>
                                        <label className='form-label'>Check Out</label>
                                        <input
                                            type='date'
                                            className='form-control'
                                            value={checkOut}
                                            onChange={(e) => setCheckOut(e.target.value)}
                                        />
                                    </div>

                                    <div className='col-md-2'>
                                        <label className='form-label'>Booking From</label>
                                        <input
                                            type='date'
                                            className='form-control'
                                            value={bookingFrom}
                                            onChange={(e) => setBookingFrom(e.target.value)}
                                        />
                                    </div>

                                    <div className='col-md-2'>
                                        <label className='form-label'>Booking To</label>
                                        <input
                                            type='date'
                                            className='form-control'
                                            value={bookingTo}
                                            onChange={(e) => setBookingTo(e.target.value)}
                                        />
                                    </div>

                                    <div className='col-md-3 d-flex align-items-end'>

                                        <button
                                            type="button"
                                            onClick={handleClear}
                                            className='btn btn-danger'
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            </form>

                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-header">
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h4 className="card-title">Business Source Report</h4>
                                                <button className='btn btn-sm btn-primary' type="button" onClick={exportBusinessSourceToExcel}>Export</button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                {/* <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Business Source</th>
                                                            <th>OCC</th>
                                                            <th>PAX</th>
                                                            <th>Revenue</th>
                                                            <th>ARR</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {data && data.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.BusinessSource}</td>
                                                                <td>{item.OCC}</td>
                                                                <td>{item.PAX}</td>
                                                                <td>{item.Revenue}</td>
                                                                <td>{item.ARR}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>

                                                </table> */}

                                                <DataTable
                                                    value={data}
                                                    // paginator

                                                    rows={10}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    showGridlines
                                                    stripedRows
                                                    responsiveLayout="scroll"
                                                    className="p-datatable-bordered"
                                                    filterDisplay="row"   // 🔥 header ke niche filter box
                                                    emptyMessage="No records found"
                                                >
                                                    <Column
                                                        field="BusinessSource"
                                                        header="Business Source"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />

                                                    <Column
                                                        field="OCC"
                                                        header="OCC"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />

                                                    <Column
                                                        field="PAX"
                                                        header="PAX"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />

                                                    <Column
                                                        field="Revenue"
                                                        header="Revenue"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />

                                                    <Column
                                                        field="ARR"
                                                        header="ARR"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
